<div class="p-0 summary-block-simplified">
  @if (timelineData) {
    <div class="d-flex align-items-center">
      <span class="summary-title">{{ 'summary' | translate }}</span>
    </div>
    <div class="d-flex align-items-center flex-wrap summary-row" [class.no-description]="!timelineData?.description">
      <div class="field">
        <div class="label">{{ 'name' | translate }}</div>
        <div class="value">{{ timelineData?.name }}</div>
      </div>
      @if (workspaceName) {
        <div class="field">
          <div class="label">{{ 'workspace' | translate }}</div>
          <div class="value">{{ workspaceName }}</div>
        </div>
      }
      <div class="field">
        <div class="label">Launch Date</div>
        <div class="value">{{ formattedDate ? (formattedDate | ngbDate) : 'NA' }} </div>
      </div>
      @if (timelineData.projectLeaders?.length) {
        <div class="field">
          @if (campaignMainConfig.hasProductDevManager) {
            <div class="label">{{ 'ProductDevManager' | translate }}</div>
          }
          @if (campaignMainConfig.hasLeader) {
            <div class="label">{{ 'campaignLeader' | translate }}</div>
          }
          <div class="d-flex justify-content-start align-items-center">
            <div class="ms-1 d-flex">
              @for (user of timelineData?.projectLeaders; track $index) {
                <div class="user-avatar" [style.z-index]="$index + 1" [style.left]="`${-1 * ($index * 8)}px`">
                  <mtm-user-profile-picture
                    placement="left"
                    container="body"
                    [ngbTooltip]="selectedParticipantTooltip"
                    [username]="user"
                    [height]="24"
                    [width]="24">
                  </mtm-user-profile-picture>
                  <ng-template #selectedParticipantTooltip>
                    <div class="user-tooltip d-flex flex-column align-items-start p-1">
                      <h6 class="user-name m-0">{{ getUserInfo(user) }}</h6>
                    </div>
                  </ng-template>
                </div>
              }
            </div>
          </div>
          @if (timelineData?.projectLeaders == null) {
            <div
              ><span>{{ 'NA' | translate }}</span></div
            >
          }
        </div>
      }
      @if (!!timelineData?.description) {
        <div class="field description-field">
          <div class="label">{{ 'description' | translate }}</div>
          <div class="value">{{ timelineData.description }}</div>
        </div>
      }
    </div>
  }
</div>
